import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
    read_avatar_label,
    read_avatar_url,
    read_member_name
} from "../utils/sales_helpers";

const ProspectLeadAvatar = styled.div`
    width: ${p => p.sizeValue};
    height: ${p => p.sizeValue};
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${p => p.theme.mid};
    flex-shrink: 0;
`;

const ProspectLeadAvatarImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;

/**
 * Renders a compact HR member avatar with initials fallback.
 */
export const Sales_Lead_Avatar = (props) => {
    const label = `${props?.label || props?.name || read_member_name(props?.member) || ""}`.trim();
    const sizeValue = props?.size || "2.8rem";
    const avatarSrc = read_avatar_url(props?.member);
    const [imageVisible, setImageVisible] = useState(Boolean(avatarSrc));

    useEffect(() => {
        setImageVisible(Boolean(avatarSrc));
    }, [avatarSrc]);

    return (
        <ProspectLeadAvatar sizeValue={sizeValue} title={props?.title || label}>
            {imageVisible ? (
                <ProspectLeadAvatarImage src={avatarSrc} alt={props?.title || label || "User avatar"} onError={() => setImageVisible(false)} />
            ) : (
                <h6>{read_avatar_label(label)}</h6>
            )}
        </ProspectLeadAvatar>
    );
};
